import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AzureTableStorageLinkedService } from '../linkedservice/azure-table-storage.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.azureTable.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureTableStorage_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureTableStorage_DisplayText)
    ],
    constraints: __IS_FABRIC_DPE__ ? {
        linkedService: {
            model: AzureTableStorageLinkedService.MODEL // Linked service redefined
        }
    } : undefined
})
export class AzureTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
